import React from 'react';
import Chart from "react-apexcharts";

interface Iprops {
  years?: any[],
  series?: any[]
}

const BarChart = ({
  years,
  series
}: Iprops) => {
  
  
  const options: any = {
    series: series,
    chart: {
      type: 'bar',
      height: 100,
      stacked: true,
    },
    plotOptions: {
      bar: {
        barHeight: 30,
        columnWidth: "20%",
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: '14px',
              fontWeight: 900
            }
          }
        }
      },
    },
    colors: [
      "#54ace9",
      "#1890ff",
      "#BFE6F8",
      "#65BD7B"
    ],
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: years,
      labels: {
        formatter: function (val:string) {
          return val
        }
      }
    },
    yaxis: {
      title: {
        text: undefined
      },
    },
    tooltip: {
      y: {
        formatter: function (val:string) {
          return val
        }
      }
    },
    fill: {
      opacity: 1
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
      offsetX: 0
    }
  };

  return (
    <div className="chart-wrapper">
      <Chart
        options={options}
        series={options.series}
        type="bar"
        height="220"
      />
    </div>
  )
}

export default BarChart;